enum EXTERNAL_LINK_METHOD {
    LOCATION = "LOCATION",
    LOCATION_HREF = "LOCATION_HREF",
    BLANK = "BLANK",
}

export default EXTERNAL_LINK_METHOD;
